import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-489b8f36"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cookie-consent"
}
const _hoisted_2 = { class: "cookie-consent-inner" }
const _hoisted_3 = { class: "cookie-text" }
const _hoisted_4 = { class: "cookie-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide-up" }, {
    default: _withCtx(() => [
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, [
                _createTextVNode(" 본 사이트는 서비스 제공 및 사용자 경험 개선을 위해 쿠키와 Google Analytics를 사용합니다. "),
                _createVNode(_component_router_link, {
                  to: "/user/terms",
                  class: "cookie-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 개인정보 처리방침 ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "cookie-btn cookie-btn-accept",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)))
                }, " 동의 "),
                _createElementVNode("button", {
                  class: "cookie-btn cookie-btn-decline",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.decline && _ctx.decline(...args)))
                }, " 거부 ")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}